// src/theme/theme.js
import { createTheme } from "@mui/material/styles";

// Light Green Theme
export const lightTheme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#2e7d32", // Hijau tua
      light: "#4caf50", // Hijau sedang
      dark: "#1b5e20", // Hijau sangat tua
      contrastText: "#ffffff",
    },
    secondary: {
      main: "#00897b", // Teal/hijau kebiruan
      light: "#4db6ac", // Teal muda
      dark: "#00695c", // Teal tua
      contrastText: "#ffffff",
    },
    success: {
      main: "#2e7d32",
      light: "#4caf50",
      dark: "#1b5e20",
    },
    background: {
      default: "#f1f8f1", // Hijau sangat muda
      paper: "#ffffff",
    },
    text: {
      primary: "rgba(0, 0, 0, 0.87)",
      secondary: "rgba(0, 0, 0, 0.6)",
    },
    divider: "rgba(0, 0, 0, 0.12)",
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
        },
        contained: {
          boxShadow: "0 2px 4px rgba(46, 125, 50, 0.2)",
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: "#2e7d32",
          color: "#ffffff",
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderLeft: "4px solid #4caf50",
        },
      },
    },
  },
});

// Dark Green Theme
export const darkTheme = createTheme({
  palette: {
    mode: "dark",
    primary: {
      main: "#66bb6a", // Hijau terang
      light: "#81c784", // Hijau sangat terang
      dark: "#388e3c", // Hijau gelap
      contrastText: "#000000",
    },
    secondary: {
      main: "#26a69a", // Teal terang
      light: "#4db6ac", // Teal muda
      dark: "#00796b", // Teal gelap
      contrastText: "#000000",
    },
    success: {
      main: "#66bb6a",
      light: "#81c784",
      dark: "#388e3c",
    },
    background: {
      default: "#0d1f0d", // Hijau sangat gelap
      paper: "#1a2e1a", // Hijau gelap
    },
    text: {
      primary: "#e8f5e9", // Hijau sangat muda
      secondary: "rgba(255, 255, 255, 0.7)",
    },
    divider: "rgba(255, 255, 255, 0.12)",
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
        },
        contained: {
          boxShadow: "0 2px 4px rgba(102, 187, 106, 0.3)",
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: "#1a2e1a",
          color: "#e8f5e9",
          borderBottom: "1px solid #2e7d32",
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderLeft: "4px solid #66bb6a",
          backgroundColor: "#1a2e1a",
        },
      },
    },
  },
});

// Export default theme (opsional)
export const defaultTheme = lightTheme;
